import { render, staticRenderFns } from "./UserRankingTableItem.vue?vue&type=template&id=e8e53e92&scoped=true&"
import script from "./UserRankingTableItem.vue?vue&type=script&lang=js&"
export * from "./UserRankingTableItem.vue?vue&type=script&lang=js&"
import style0 from "./UserRankingTableItem.vue?vue&type=style&index=0&id=e8e53e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e53e92",
  null
  
)

export default component.exports